import { put, all } from 'redux-saga/effects'

export function * initUserDetailsWindow(action) {
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'me',
      method: 'read',
      obj: null,
      id: null
    }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'user_group',
      method: 'read',
      obj: null,
      id: null
    })
  ])
}
